import React from 'react'
import injectSheet from 'react-jss'
import styles from './permission-warning.styles'
import { Modal, ModalContent } from 'pobble-components/dist/modal'
import PobbleLink from 'pobble-components/dist/pobble-link'
import Button from 'pobble-components/dist/button'

const PermissionWarning = ({ classes, action, ...props }) => {
  return (
    <Modal {...props} closeButton>
      <ModalContent className={classes.content}>
        <div className={classes.holder}>
          <p>
            Publishing writing on Pobble makes it fun and easy to regularly
            celebrate your young writers' achievements. You can find out more
            about publishing{' '}
            <PobbleLink
              target="_blank"
              href="https://www.pobble.com/publishing">
              here
            </PobbleLink>
            .
          </p>
          <p>
            Published writing will appear publicly on your school celebration
            page. We recommend you inform parents/carers that you intend to
            publish their child's work. You can find a pre-written letter to
            support you with this in our Knowledge Base.
          </p>
          <p>
            Remember, only teachers can publish work. You can disable publishing
            for any pupils in the 'My Pupils' area of your account or in an
            individual pupil's profile.
          </p>
        </div>
        <div className={classes.actions}>
          <Button tall simple action={props.requestClose}>
            Cancel
          </Button>
          <Button
            action={() => {
              props.requestClose()
              action && action()
            }}
            tall>
            Proceed
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}

export default injectSheet(styles)(PermissionWarning)
